import { Button, Checkbox, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material"
import { LeasesMenuList, LeasesNav } from "../../../elements";
import RelatedLoansList from "../components/RelatedLoansList";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { useEffect, useState } from "react";
import RelatedLoansCRU from "../components/RelatedLoansCRU";
import { DeletePopUp, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import { useParams } from "react-router-dom";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { deleteRelatedLoansApi, getRelatedLoansApi } from "../apiService";
import { checkApiStatus } from "../../../../utils";
import { enqueueSnackbar } from "notistack";
import { ButtonLoader, ShowAttachments } from "../../../../shared_elements/components";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from "../../../elements/LeasesBasicDetails";
import { trackActivity } from "../../../../utils/mixpanel";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../../shared_elements/actionCreators';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const RelatedLoansHd = ({ sortInfo, createSortHandler, bulk, item, toggleBulkOps }) => {
    const tableSorting = (key, name) => (
        <TableSortLabel
            sx={{ whiteSpace: 'nowrap' }}
            active={sortInfo?.sort_by === key}
            direction={sortInfo?.sort_by === key ? sortInfo.sort : 'asc'}
            onClick={() => createSortHandler(key)}
        >
            <span style={{ color: sortInfo?.sort_by === key ? '#496ac5' : 'inherit' }}>{name}</span>
        </TableSortLabel>
    );
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => { toggleBulkOps(e.target.checked, "bulk", item) }} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '100px' }}>{tableSorting("name", "Name")}</TableCell>
                <TableCell sx={{ minWidth: '100px' }}>{tableSorting("loan_status", "Loan Status")}</TableCell>
                <TableCell sx={{ minWidth: '100px' }}>{tableSorting("description", "Description")}</TableCell>
            </TableRow>
        </TableHead>
    )
}
const RelatedLoans = () => {
    const dispatch = useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const [addEditRelatedLoans, setAddEditRelatedLoans] = useState({ modal: false, mode: "", data: null });
    const [deleteRelatedLoans, setDeleteRelatedLoans] = useState({ modal: false, data: null });
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [bulk, setBulk] = useState({ modal: false, type: "", ids: [], title: "" })
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const [relatedLoanInfo, setRelatedLoanInfo] = useState([]);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [uploadFileList, setUploadFileList] = useState({ modal: false, mode: "", data: null })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})


    useEffect(() => {
        const uploadedFileData = getApiResponse("related_loan", slug);
        getRelatedLoansList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'Related Loans'})
        setUploadFileProgressData({uploadedFileData});
    }, []);
    const getRelatedLoansList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getRelatedLoansApi(params, query), {}).then(response => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            if (checkApiStatus(response)) {
                setRelatedLoanInfo(response?.data?.data);
            }
        })
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"related_loan"}))

    };

    const onDeleteRelatedLoans = () => {
        setLoading(true);
        const idsToDelete = deleteRelatedLoans?.modal && deleteRelatedLoans?.data?.id ? [deleteRelatedLoans?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteRelatedLoansApi(params), { ids: idsToDelete })
        .then(response => {
            if (checkApiStatus(response)) {
                trackActivity('Item Deleted', { page_title: `Delete Amendment`, success_msg: response?.data?.message, item_ids: deleteRelatedLoans?.data || bulk?.ids, response: response?.data })
                setDeleteRelatedLoans({ modal: false, data: null })
                setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                getRelatedLoansList('', { per_page: relatedLoanInfo?.pagination?.per_page });
            }
            else {
                setLoading(false);
                enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                trackActivity('Item Deleted', { page_title: `Delete Amendment`, error_msg: response?.data?.message, item_ids: deleteRelatedLoans?.data || bulk?.ids, response: response?.data })
            }
        })
    }
    const toggleBulkOps = async (flag, type, item) => {
        try {
            if (type === "bulk") {
                setBulk({ ...bulk, type: "bulk", ids: flag ? item : [] })
            }
            else {
                setBulk({ ...bulk, type: "single", ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
            }
        }
        catch (error) {
            console.error("Error Fetching Data:", error);
        }
    }
    const onDeleteAttachments = (deletdslug) => {
        setUploadFileList({ ...uploadFileList, data: { ...uploadFileList?.data, attachments: uploadFileList?.data?.attachments.filter(item => item?.slug !== deletdslug) } })
        getRelatedLoansList('', { per_page: relatedLoanInfo?.pagination?.per_page });
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' };
        }
        setSortInfo(sortQuery);
        getRelatedLoansList('', { ...sortQuery, per_page: relatedLoanInfo?.pagination?.per_page || 50 });
    };
    const handleExport=()=>{
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = { ...query, sort: sortInfo.sort, sort_by: sortInfo.sort_by }
        }
    seIsExport(true);
    globalGetService(getRelatedLoansApi(params , query)).then((response)=>{
        if (checkApiStatus(response)){
          enqueueSnackbar(
                 response?.data.message,
                 { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
               );
                seIsExport(false);
        }
    })
  }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Related Loans`, page_type: page_type, })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
      await fileUpload({
      attachments: fileUploadDetails.attachments,
      module_name: "related_loan",
      slug: slug,
      query: { record_action_type: mode },
      onStart: () => setLoading(true),
      onComplete: () => setLoading(false),
      onProgress: ({ progressRefs, attachments ,response}) => {
               setUploadFileProgressData({ progressRefs, attachments ,response});
      },
     onSuccess: (success_msg) => {
      enqueueSnackbar(success_msg, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
       getRelatedLoansList("", { per_page: relatedLoanInfo?.pagination?.per_page || 50 });
     },
     onError: (err) => {
      enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
     }
     });
       setSlug({})
    };

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="technical"/>
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Related Loans" type="technical"/>
                            </Grid>
                             <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {
                                        bulk?.type && bulk.ids.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button size="small" variant="outlined" color="primary" onClick={() => { setBulk({ modal: false, type: "", ids: [], title: "" });handleItemClicked('Bulk Delete Cancel Button') }}>Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button size="small" variant="outlined" color="primary" onClick={() => { setBulk({ ...bulk, modal: true, title: "Delete" }) ;handleItemClicked('Bulk Delete Button') }} sx={{ backgroundColor: "#f50057", borderColor: "#f50057", color: "#fff" }}>{`Delete(${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {relatedLoanInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => {handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'>
                                            <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" size="small" color="primary" onClick={() => { setAddEditRelatedLoans({ modal: true, mode: "add", data: { name: "", loan_status: false, description: "" } }); handleItemClicked('Add Item Button') }}>Add Related Loan</Button>
                                        </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: relatedLoanInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                                <Table className="mui-table-format" stickyHeader>
                                    <RelatedLoansHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} toggleBulkOps={toggleBulkOps} item={relatedLoanInfo.list} />
                                    <TableBody>
                                      {relatedLoanInfo?.list?.length > 0 && (
                                        relatedLoanInfo.list.map((item, index) => {
                                              const uploadedFileData = getApiResponse("related_loan", item?.slug);

                                            return (
                                            <RelatedLoansList
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData }
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onDelete={() => {
                                                    setDeleteRelatedLoans({ modal: true, data: item });
                                                    setBulk({modal: false, ids: [item], type: ''})
                                                }}
                                                onView={() => setAddEditRelatedLoans({ modal: true, mode: "view", data: item })}
                                                onEdit={() => setAddEditRelatedLoans({ modal: true, mode: "edit", data: item })}
                                                viewFile={() => setUploadFileList({ modal: true, mode: "file", data: item })}
                                                bulk={bulk}
                                                toggleBulkOps={toggleBulkOps}
                                            />
                                            );
                                        }))}

                                    </TableBody>
                                </Table>
                            )}
                        </div>
                        <Paper square>
                            {!skeletonLoader && !relatedLoanInfo?.list?.length && <NoRecordFound />}
                            <Pagination
                                pagination={relatedLoanInfo?.pagination}
                                onPageChange={(e, newPage) => { const pageNum = newPage + 1; getRelatedLoansList('Pageloader', { page: pageNum, per_page: relatedLoanInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                                onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getRelatedLoansList('Pageloader', { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }} />
                        </Paper>
                    </Paper>
                </div>
                {
                    uploadFileList?.modal ? 
                        <ShowAttachments
                        url="delete-attachment"
                        moduleName="Related Loans"
                        attachmentsData={uploadFileList}
                        getResponseBack={onDeleteAttachments}
                        toggleModalFn={() => setUploadFileList({ modal: false, data: null, mode:'' })}
                        onViewDisabled={addEditRelatedLoans?.mode === 'view' || uploadFileList?.mode==='view'}
                        permissionKey='related_loan'

                    /> : null
                }
                {
                    addEditRelatedLoans.modal ? <RelatedLoansCRU
                        params={params}
                        fileUpload={handleUpload}
                        addEditRelatedLoans={addEditRelatedLoans}
                        modeType={addEditRelatedLoans.mode}
                        getResponseBack={() => {getRelatedLoansList('', { per_page: relatedLoanInfo?.pagination?.per_page || 10 }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                        onToggleModal={() => setAddEditRelatedLoans({ modal: false, mode: "", data: null })}
                        onOpenAttachments={() => setUploadFileList({ modal: true, data: addEditRelatedLoans.data, mode:'view' })} /> : null
                }
                {
                    deleteRelatedLoans.modal ? <DeletePopUp
                        modal={deleteRelatedLoans.modal}
                        title="Delete Related Loan"
                        content="Are you sure,you want to delete Related Loan"
                        onToggleModal={() => setDeleteRelatedLoans({ modal: false, data: null })}
                        onDeleteRecords={() => onDeleteRelatedLoans()}
                    /> : null
                }
                {
                    bulk.modal ? <DeletePopUp
                        modal={bulk.modal}
                        title={`Delete ${bulk?.type === "bulk" && bulk?.ids?.length === (relatedLoanInfo?.list?.length || 0) ? "All Related Loans" : "Selected Related Loan(s)"}`}
                        content={`Are you sure, you want to delete ${bulk?.ids?.length > 1 ? "these" : "this"} record?`}
                        onToggleModal={() => setBulk({ modal: false, type: "", ids: [] })}
                        onDeleteRecords={() => onDeleteRelatedLoans()}
                    /> : null
                }
                { revisionHistory.modal &&   
                     <RevisionHistory 
                      moduleName={"related_loan"}
                      revisionHistory={revisionHistory}
                      onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                     />
                }
                 <FileUploadLayout
                    uploadFileStatus={uploadFileStatus}
                    open={uploadFileStatus?.modal}
                    setUploadFileStatus={setUploadFileStatus}
                    uploadFileProgressData={uploadFileProgressData}
                    progressRefs={uploadFileProgressData?.progressRefs}
                    attachments={uploadFileProgressData?.attachments}
                    onDownloadComplete={()=> setSlug({})}
                 />
                {isLoading ? <PageLoader /> : null}
            </Paper>
        </>
    )
}
export default RoleBaseAccess(RelatedLoans, { application: 'lease_revamp', feature: 'related_loan', operationType: ['R'], leaseNav: true });